import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import router from "./routes/route";
import { RecoilRoot } from "recoil";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <RecoilRoot>
      <RouterProvider router={router} />
    </RecoilRoot>
  </ErrorBoundary>,
);
